export { migrationPublishMessages } from './messages';

export const MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM = 'migrationPublished';

const DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH = '/servicedesk/customer/test/portals';
const DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH = '/servicedesk/customer/test';
const HELP_CENTER_PREVIEW_PATH_PREFIX = '/helpcenter/test/';

export const isDefaultHelpCenterPortalsPreviewPath = (pathname: string): boolean =>
	pathname === DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH ||
	pathname === `${DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH}/`;

/**
 * Identifies the view base path returned for a sandbox Help Center. The backend
 * owns the path shape, so consumers use this only to choose sandbox behaviour,
 * never to construct a Help Center URL.
 */
export const isSandboxHelpCenterBasePath = (basePath: string): boolean => {
	const normalizedBasePath = basePath.replace(/\/+$/, '');

	return (
		normalizedBasePath === DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH ||
		normalizedBasePath === DEFAULT_HELP_CENTER_SANDBOX_BASE_PATH ||
		(normalizedBasePath.startsWith(HELP_CENTER_PREVIEW_PATH_PREFIX) &&
			normalizedBasePath.length > HELP_CENTER_PREVIEW_PATH_PREFIX.length)
	);
};

export const getMigrationPublishedUrl = (url: string): string => {
	const destination = new URL(url);
	destination.searchParams.set(MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM, 'true');
	return destination.toString();
};
